'use client'

import Script from 'next/script'
import { usePageStore } from '../libs/hooks/usePageStore'

type FacebookPixelProps = { pixelId: string }

const FacebookPixel = ({ pixelId }: FacebookPixelProps) => {
  return (
    <div>
      <Script
        id="fb-pixel"
        src="/scripts/pixel.js"
        strategy="afterInteractive"
        onLoad={() => usePageStore.setState({ isFbPixelLoaded: true })}
        data-pixel-id={pixelId}
      />
      {/* <noscript>
        <img
          height="1"
          alt="fbpixel"
          width="1"
          style={{ display: 'none' }}
          src={`https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`}
        />
      </noscript> */}
    </div>
  )
}

export default FacebookPixel
